import { CollaboratorCursor } from '../../Types/whiteboard';
import { MAX_REMOTE_VERSION_HASH_LIST } from './constants';

export interface WhiteboardState {
	isLoading: boolean;
	collaboratorCursors: Map<number, CollaboratorCursor>;
	isHydrating: boolean;
	lastVersionHash: string;
	recentRemoteHashes: string[];
	hasJoinedSignalR: boolean;
	lastPresenceUpdate: number;
}

export type WhiteboardAction =
	| { type: 'SET_LOADING'; payload: boolean }
	| { type: 'SET_HYDRATING'; payload: boolean }
	| { type: 'SET_JOINED_SIGNALR'; payload: boolean }
	| { type: 'UPDATE_CURSOR'; payload: { userId: number; x: number; y: number; userName?: string } }
	| { type: 'CLEAN_STALE_CURSORS' }
	| { type: 'UPDATE_LAST_VERSION_HASH'; payload: string }
	| { type: 'ADD_REMOTE_HASH'; payload: string }
	| { type: 'SET_PRESENCE_UPDATE_TIME'; payload: number };

export function whiteboardReducer(state: WhiteboardState, action: WhiteboardAction): WhiteboardState {
	switch (action.type) {
		case 'SET_LOADING':
			return { ...state, isLoading: action.payload };
		case 'SET_HYDRATING':
			return { ...state, isHydrating: action.payload };
		case 'SET_JOINED_SIGNALR':
			return { ...state, hasJoinedSignalR: action.payload };
		case 'UPDATE_CURSOR': {
			const { userId, x, y, userName } = action.payload;
			const newCursors = new Map(state.collaboratorCursors);
			newCursors.set(userId, {
				x,
				y,
				userId,
				userName,
				lastSeen: Date.now(),
			});
			return { ...state, collaboratorCursors: newCursors };
		}
		case 'CLEAN_STALE_CURSORS': {
			const now = Date.now();
			const newCursors = new Map(state.collaboratorCursors);
			for (const [userId, cursor] of newCursors.entries()) {
				if (now - cursor.lastSeen > 3000) {
					// Remove cursors after 3 seconds of inactivity
					newCursors.delete(userId);
				}
			}
			return { ...state, collaboratorCursors: newCursors };
		}
		case 'UPDATE_LAST_VERSION_HASH':
			return { ...state, lastVersionHash: action.payload };
		case 'ADD_REMOTE_HASH': {
			console.log('Adding remote version hash:', action.payload);
			const newHashes = [...state.recentRemoteHashes, action.payload];
			if (newHashes.length > MAX_REMOTE_VERSION_HASH_LIST) {
				newHashes.shift();
			}
			return { ...state, recentRemoteHashes: newHashes };
		}
		case 'SET_PRESENCE_UPDATE_TIME':
			return { ...state, lastPresenceUpdate: action.payload };
		default:
			return state;
	}
}
